/** Kontaktblock auf der Share-Score-Card (auch von HTML-Templates genutzt). */
export const SHARE_CONTACT = {
  name: 'Lena Langkamp',
  role: 'New Business Operations Manager',
  email: 'l.langkamp@ambition-performance.de',
  phone: '0541 343 717 58',
  imageUrl: '/assets/contact/lena.jpg',
} as const;

export type ShareContact = typeof SHARE_CONTACT;
